(function () {
    'use strict';

    angular.module('app')
        .config(ngRouteConfig);

    function ngRouteConfig($routeProvider) {
        $routeProvider
            .when('/', {
                templateUrl: 'controller/home/home.index.html',
                controller: 'homeController as vm',
                resolve: {
                    viewModel: function (homeService) {
                        return homeService.getMhr();
                    }
                }
            })
            .when('/login', {
                controller: 'loginController as vm',
                templateUrl: 'controller/login/login.index.html',
                resolve: {
                    viewModel: function (loginService) {
                        return loginService.get();
                    }
                }
            })
            .when('/token:token', {
                controller: 'rootController as vm'
            })
            .when('/verifyCode/:verifyCode/:email/:sysCode', {
                controller: 'verifyCodeController as vm',
                templateUrl: 'controller/login/login.verifyCode.html'
            })
            .when('/login/forceEditPwd', {
                controller: 'loginForceEditPwdController as vm',
                templateUrl: 'controller/login/login.forceEditPwd.html'
            })
            .when('/login/directEditPwd/:userAccount/:verifyCode/:mobilTel?', {
                controller: 'loginDirectEditPwdController as vm',
                templateUrl: 'controller/login/login.directEditPwd.html'
            })


            .when('/login/forgetPwdDirectEditPwd/:userAccount/:verifyCode', {
                templateUrl: 'controller/login/login.forgetPwdDirectEditPwd.html',
                controller: 'loginForgetPwdDirectEditPwdController as vm'
            })

            .when('/tsu/', {
                controller: 'tsunHomeController as vm',
                templateUrl: 'controller/tsun/home/home.index.html',
                resolve: {
                    viewModel: function (homeService) {
                        return homeService.getTsu();
                    }
                }
            })
            .when('/tsu/course', {
                templateUrl: 'controller/tsun/training/course/course.index.html',
                controller: 'tsunCourseController as vm',
                resolve: {
                    // translate: function (translateService) {
                    //     return translateService.getTranslates()
                    //         .then(function (data) { return data; });
                    // },
                    userInfo: function (loginService, $rootScope) {
                        return loginService.getSsoInfo().then(function (data) {
                            $rootScope.userInfo = data.data;
                            return $rootScope.userInfo;
                        });
                    },
                    urlParam: function ($routeParams) {
                        return $routeParams;
                    }
                }
            })
            .when('/tsu/training', {
                templateUrl: 'controller/tsun/training/myTraining/myTraining.index.html',
                controller: 'tsunMyTrainingController as vm',
                resolve: {
                    // translate: function (translateService) {
                    //     return translateService.getTranslates()
                    //         .then(function (data) { return data; });
                    // },
                    ssoInfo: function (loginService, $rootScope) {
                        return loginService.getSsoInfo().then(function (data) {
                            $rootScope.userInfo = data.data;
                            return data.data;
                        });
                    }
                }
            })
            .when('/tsu/shoppingCart', {
                templateUrl: 'controller/tsun/training/courseCollection/shoppingCart.index.html',
                controller: 'tsunShoppingCartController as vm',
                resolve: {
                    // translate: function (translateService) {
                    //     return translateService.getTranslates()
                    //         .then(function (data) { return data; });
                    // },
                    ssoInfo: function (loginService, $rootScope) {
                        return loginService.getSsoInfo().then(function (data) {
                            $rootScope.userInfo = data.data;
                            return data.data;
                        });
                    }
                }
            })
            .when('/tsu/recommend2', {
                templateUrl: 'controller/tsun/training/recommend/recommend.index.html',
                controller: 'tsunRecommendController as vm',
                resolve: {
                    // translate: function (translateService) {
                    //     return translateService.getTranslates()
                    //         .then(function (data) { return data; });
                    // },
                    activeType: function () {
                        return 2;
                    }
                }
            })
            .when('/tsu/recommend3', {
                templateUrl: 'controller/tsun/training/recommend/recommend.index.html',
                controller: 'tsunRecommendController as vm',
                resolve: {
                    // translate: function (translateService) {
                    //     return translateService.getTranslates()
                    //         .then(function (data) { return data; });
                    // },
                    activeType: function () {
                        return 3;
                    }
                }
            })
            .when('/tsu/recommendHTML', {
                templateUrl: 'controller/tsun/training/recommend/recommend.Doc.html',
                controller: 'tsunRecommendDocController as vm',
                resolve: {}
            })
            .when('/tsu/visualpage/:pageSerilNo', {
                templateUrl: 'controller/tsun/visualpage/visualpage.index.html',
                controller: 'visualpageController as vm',
                resolve: {
                    viewModel: function (visualPageService, $route) {
                        return visualPageService.get($route.current.params.pageSerilNo);
                    }
                }
            })
            .when('/tsu/bulletin/more', {
                templateUrl: 'controller/tsun/bulletin/bulletin.more.html',
                controller: 'tsunBulletinMoreController as vm',
                resolve: {
                    viewModel: function (bulletinService) {
                        return bulletinService.getNoticeMore();
                    }
                }
            })
            .when('/tsu/bulletin/noticeDetail/:no?/:isBulletin?', {
                templateUrl: 'controller/tsun/bulletin/bulletin.noticeDetail.html',
                controller: 'tsunBulletinNoticeDetailController as vm',
                resolve: {
                    viewModel: function (bulletinService, $route) {
                        return bulletinService.getByNoForTsun($route.current.params.no);
                    }
                }
            })
            .when('/bulletin/more/:isHistory?', {
                templateUrl: 'controller/bulletin/bulletin.more.html',
                controller: 'bulletinMoreController as vm',
                resolve: {
                    viewModel: function (bulletinService, enumService, $route) {
                        return bulletinService.getMore(enumService.siteCode.hrOutside, $route.current.params.isHistory);
                    }
                }
            })
            .when('/bulletin/detail/:no', {
                templateUrl: 'controller/bulletin/bulletin.detail.html',
                controller: 'bulletinDetailController as vm',
                resolve: {
                    viewModel: function (bulletinService, $route) {
                        return bulletinService.getByNo($route.current.params.no);
                    }
                }
            })
            .when('/header/searchResult/:keyword?/:siteCode?', {
                templateUrl: 'controller/header/header.searchResult.html',
                controller: 'headerSearchResultController as vm',
                resolve: {
                    viewModel: function (headerService, $route) {
                        return headerService.getSearchResult($route.current.params.keyword, 1 /*page*/, 1 /*all*/, $route.current.params.siteCode,true /*need Keyword Log*/);
                    },
                    siteCode: function ($route) {
                        return $route.current.params.siteCode;
                    }
                }
            })
            .when('/schedule', {
                templateUrl: 'controller/schedule/schedule.index.html',
                controller: 'scheduleController as vm',
                resolve: {
                    viewModel: function (scheduleService) {
                        return scheduleService.getCalendarArea();
                    }
                }
            })
            .when('/nextMenu', {
                templateUrl: 'controller/nextMenu/nextMenu.index.html',
                controller: 'nextMenuController as vm',
                resolve: {
                    viewModel: function (homeService) {
                        return homeService.getNext();
                    }
                }
            })
            .when('/nextMenu/detail/:no', {
                templateUrl: 'controller/nextMenu/nextMenu.detail.html',
                controller: 'nextMenuDetailController as vm',
                resolve: {
                    viewModel: function (bulletinService, $route) {
                        return bulletinService.getByNo($route.current.params.no);
                    }
                }
            })
            .when('/mobile/trigger/', {
                templateUrl: 'controller/mobile/mobile.trigger.html',
                controller: 'mobileTriggerController as vm'
            })
            .when('/common/index/', {
                templateUrl: 'controller/common/common.index.html',
                controller: 'commonController as vm'
            })
            .when('/external', {
                templateUrl: 'controller/external/external.index.html',
                controller: 'externalController as vm'
            })
             .when('/external/schemaTransfer', {
                templateUrl: 'controller/external/external.schemaTransfer.html',
                controller: 'externalSchemaTransferController as vm'
            })
            .otherwise({
                redirectTo: '/'
            });
    }

})();
